var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oie-my-pages-template',{attrs:{"title":_vm.t('deliveryTitle'),"text":_vm.t('deliverySubTitle')}},[_c('oie-delivery-addresses-crud'),_c('oie-preferred-delivery-methods')],1)}
var staticRenderFns = []

export { render, staticRenderFns }